<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="characText"
    item-value="inspCharacDtlNo"
    :label="label"
    :exceptCdList="exceptCdList"
    :exceptComparator="exceptComparator"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import { MeasFmtCd } from '@/enum'

export default {
  name: 'InspCharacDtlInput',

  mixins: { APIUtils, Message },
  components: { SelectSingleInput },

  props: {
    value: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0091')
      },
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    partCd: {
      type: String,
      required: true,
    },
    inspCharacRev: {
      type: Number,
      required: false,
      default: null,
    },
    exceptCdList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : null)

        this.$emit(
          'selectedItem',
          this.items.find((item) => item.inspCharacDtlNo == value),
        )
      },
    },
  },

  methods: {
    exceptComparator(item, except) {
      return item.inspCharacDtlNo == except.inspCharacDtlNo && item.inspCharacDtlNo != this.model
    },
  },

  async mounted() {
    if (this.partCd && this.inspCharacRev) {
      this.loading = true

      try {
        let params = { partCd: this.partCd, revNo: this.inspCharacRev, measFmtCd: MeasFmtCd.NUMBER }
        if (this.validOnly) {
          params.validOnly = true
        }

        const elements = await API.get('/master/inspCharacDtls', params)
        elements.forEach((element) => {
          if (element['inspCharacPoint']) {
            element['characText'] = `${element['inspCharacCd']} - ${element['inspCharacPoint']}`
          } else {
            element['characText'] = `${element['inspCharacCd']}`
          }
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0091') })))
      } finally {
        this.loading = false
      }
    }
  },
}
</script>
